import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
moment.locale("id");
export const FinalReportCardMAPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setAppBar({ title: "Rapor MA", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Rapor MA",
    });
  }, [setHeader, setAppBar]);

  const getArabicNumber = (num: string) => {
    const arabicNumbers = ["۰", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];

    return num
      ?.toString()
      .split("")
      .map((digit) => arabicNumbers[parseInt(digit)])
      .join("");
  };

  return (
    <>
      <div className="tw-flex tw-justify-center">
        <div
          className="tw-origin-top tw-w-[670px] tw-scale-[0.5] md:tw-scale-100 md:tw-w-[700px]"
          style={{
            transformOrigin: "top center",
          }}
        >
          <div className="tw-w-[670px] md:tw-w-[700px]">
            <div className="tw-bg-other-100 tw-rounded-lg tw-px-2 tw-py-4">
              {/* header */}
              <div className="tw-w-full tw-py-1 tw-text-[10px] md:tw-text-base">
                <div className="tw-flex tw-justify-between tw-mb-2 tw-text-right">
                  <div className="tw-w-[30%]">{state.kelasArabic} : </div>
                  <div className="tw-w-[16%]">الصف</div>
                  <div className="tw-w-[30%]">{state.siswaArabic} : </div>
                  <div className="tw-w-[16%]">اسم الطالب</div>
                </div>
                <div className="tw-flex tw-justify-between tw-mb-2 tw-text-right">
                  <div className="tw-w-[30%]">
                    {state.semester === "1" ? " الأول" : "الثاني"} :
                  </div>
                  <div className="tw-w-[16%]">الفصل الدراسي</div>
                  <div className="tw-w-[30%]">
                    {getArabicNumber(state.nis)} :{" "}
                  </div>
                  <div className="tw-w-[16%]">رقم السجل</div>
                </div>
              </div>
              {/* end of header */}

              {/* body */}
              <div className="tw-w-full tw-py-1 tw-text-[10px] tw-mt-3 md:tw-text-base">
                {/* nilai pelajaran */}
                <div className="tw-h-[40px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div className="border-element tw-text-center tw-w-[13%]">
                    المعدل الفصلي
                  </div>
                  <div className="border-element tw-text-center tw-w-[30%] tw-p-0">
                    <div style={{ borderBottom: "1px solid #000" }}>الدرجة</div>
                    <div className="tw-w-[100%]">
                      <div
                        className="tw-inline-block tw-w-[66%]"
                        style={{ borderRight: "1.5px solid #000" }}
                      >
                        بالحرف
                      </div>
                      <div className="tw-inline-block tw-w-[33%]">بالرقم</div>
                    </div>
                  </div>
                  <div className="border-element tw-text-center tw-w-[10%]">
                    أدنى الدرجة
                  </div>
                  <div className="border-element tw-text-center tw-w-[20%]">
                    المواد الدراسية
                  </div>
                  <div className="border-element tw-text-center tw-w-[7%]">
                    الرقم
                  </div>
                  <div className="border-element tw-text-center tw-w-[20%]">
                    أقسام المواد الدراسية
                  </div>
                </div>

                <table className="tw-w-full tw-border-spacing-0">
                  <tbody>
                    {state.dataRapor.kategori.map((ktg: any, index: number) => (
                      <React.Fragment key={index}>
                        {ktg.nilai.map((nilai: any, nilaiIndex: number) => (
                          <tr key={nilaiIndex} className="tw-h-[30px]">
                            <td className="border-element tw-text-center tw-w-[13%]">
                              {getArabicNumber(nilai.ratarata)}
                            </td>
                            <td className="border-element tw-text-center tw-w-[20%]">
                              {nilai.nilaiarabic}
                            </td>
                            <td className="border-element tw-text-center tw-w-[10%]">
                              {getArabicNumber(nilai.angka)}
                            </td>
                            <td className="border-element tw-text-center tw-w-[10%]">
                              {getArabicNumber(nilai.nilaikkm)}
                            </td>
                            <td className="border-element tw-text-right tw-w-[20%]">
                              {nilai.arabic}
                            </td>
                            <td className="border-element tw-text-center tw-w-[7%]">
                              {getArabicNumber(nilai.no)}
                            </td>
                            {nilai.namamapel === ktg.nilai[0].namamapel && (
                              <td
                                className="border-element tw-text-center tw-w-[20%]"
                                rowSpan={ktg.rowspan}
                              >
                                {ktg.kategori}
                              </td>
                            )}
                          </tr>
                        ))}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
                {/* end of nilai pelajaran */}

                {/* jumlah nilai */}
                <div className="tw-h-[30px] tw-flex tw-justify-between tw-text-[10px] tw-mt-3 md:tw-text-base">
                  <div
                    className="border-element tw-text-right tw-w-[50%]"
                    style={{ borderRight: "none" }}
                  >
                    {getArabicNumber(state.totalNilai.replaceAll(",", "."))} :
                  </div>
                  <div
                    className="border-element tw-text-right tw-w-[50%]"
                    style={{ borderLeft: "none" }}
                  >
                    مجموع الدرجات
                  </div>
                </div>
                {/* end of jumlah nilai */}

                {/* rata-rata nilai */}
                <div className="tw-h-[30px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div
                    className="border-element tw-text-right tw-w-[50%]"
                    style={{ borderRight: "none" }}
                  >
                    {getArabicNumber(state.rataNilai.replaceAll(",", "."))} :
                  </div>
                  <div
                    className="border-element tw-text-right tw-w-[50%]"
                    style={{ borderLeft: "none" }}
                  >
                    معدل التراكمي
                  </div>
                </div>

                <div className="tw-h-[30px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div
                    className="border-element tw-text-right tw-w-[50%]"
                    style={{ borderRight: "none" }}
                  >
                    {state.dataRapor.peringkat[0].rataRata >= 90
                      ? "ممتاز"
                      : state.dataRapor.peringkat[0].rataRata >= 80
                      ? "جيد جدا"
                      : state.dataRapor.peringkat[0].rataRata >= 70
                      ? "جيد"
                      : state.dataRapor.peringkat[0].rataRata <= 69
                      ? "راسب"
                      : "راسب"}
                  </div>
                  <div
                    className="border-element tw-text-right tw-w-[50%]"
                    style={{ borderLeft: "none" }}
                  >
                    التقدير
                  </div>
                </div>
                {/* end of rata-rata nilai */}

                {/* ranking */}
                <div className="tw-h-[30px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div
                    className="border-element tw-text-right tw-w-[50%]"
                    style={{ borderRight: "none" }}
                  >
                    {getArabicNumber(state.dataRapor.peringkat[0].peringkat)} :
                  </div>
                  <div
                    className="border-element tw-text-right tw-w-[50%]"
                    style={{ borderLeft: "none" }}
                  >
                    رتبته في مستواه
                  </div>
                </div>

                <div className="tw-h-[30px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div
                    className="border-element tw-text-right tw-w-[50%]"
                    style={{ borderRight: "none" }}
                  >
                    {getArabicNumber(state.dataRapor.peringkat[0].dari)} :
                  </div>
                  <div
                    className="border-element tw-text-right tw-w-[50%]"
                    style={{ borderLeft: "none" }}
                  >
                    عدد الطالب في الفصل
                  </div>
                </div>
                {/* end of ranking */}

                {/* kehadiran */}
                <table className="tw-w-full tw-border-spacing-0 tw-text-right tw-mt-3">
                  <tbody>
                    <tr className="tw-h-[30px]">
                      <td
                        className="border-element tw-w-[25%]"
                        style={{ borderRight: "none" }}
                      >
                        حصة
                      </td>
                      <td
                        className="border-element tw-w-[25%]"
                        style={{ borderRight: "none", borderLeft: "none" }}
                      >
                        {getArabicNumber(state.absen.sakit)} :
                      </td>
                      <td
                        className="border-element tw-w-[25%]"
                        style={{ borderLeft: "none" }}
                      >
                        لمرض
                      </td>
                      <td
                        className="border-element tw-text-center tw-w-[25%]"
                        rowSpan={3}
                      >
                        الغياب
                      </td>
                    </tr>

                    <tr className="tw-h-[30px]">
                      <td
                        className="border-element tw-w-[25%]"
                        style={{ borderRight: "none" }}
                      >
                        حصة
                      </td>
                      <td
                        className="border-element tw-w-[25%]"
                        style={{ borderRight: "none", borderLeft: "none" }}
                      >
                        {getArabicNumber(state.absen.ijin)} :
                      </td>
                      <td
                        className="border-element tw-w-[25%]"
                        style={{ borderLeft: "none" }}
                      >
                        بإذن
                      </td>
                    </tr>

                    <tr className="tw-h-[30px]">
                      <td
                        className="border-element tw-w-[25%]"
                        style={{ borderRight: "none" }}
                      >
                        حصة
                      </td>
                      <td
                        className="border-element tw-w-[25%]"
                        style={{ borderRight: "none", borderLeft: "none" }}
                      >
                        {getArabicNumber(state.absen.alpa)} :
                      </td>
                      <td
                        className="border-element tw-w-[25%]"
                        style={{ borderLeft: "none" }}
                      >
                        بغيرإذن
                      </td>
                    </tr>
                  </tbody>
                </table>
                {/* end of kehadiran */}

                {/* ekskul */}
                <table className="tw-w-full tw-border-spacing-0 tw-text-center tw-mt-3">
                  <tbody>
                    <tr className="tw-h-[30px]">
                      <td className="border-element tw-w-[30%]">التقدير</td>
                      <td className="border-element tw-w-[30%]">الدرجة</td>
                      <td className="border-element tw-w-[40%]">
                        المواد الإضافية
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table className="tw-w-full tw-border-spacing-0 tw-text-center">
                  <tbody>
                    <tr className="tw-h-[30px]">
                      <td className="border-element tw-w-[30%] tw-text-right">
                        {state.ekskul != null && state.ekskul.length > 0
                          ? state.ekskul[0].deskripsi_ekskul1
                          : "-"}
                      </td>
                      <td className="border-element tw-w-[30%]">
                        {state.ekskul != null && state.ekskul.length > 0
                          ? getArabicNumber(state.ekskul[0].nilai_ekskul1)
                          : "-"}
                      </td>
                      <td className="border-element tw-w-[35%] tw-text-right">
                        {state.ekskul != null && state.ekskul.length > 0
                          ? state.ekskul[0].nama_ekskul1
                          : "-"}
                      </td>
                      <td className="border-element tw-w-[5%]">
                        {getArabicNumber("1")}
                      </td>
                    </tr>

                    <tr className="tw-h-[30px]">
                      <td className="border-element tw-w-[30%] tw-text-right">
                        {state.ekskul != null && state.ekskul.length > 0
                          ? state.ekskul[0].deskripsi_ekskul2
                          : "-"}
                      </td>
                      <td className="border-element tw-w-[30%]">
                        {state.ekskul != null && state.ekskul.length > 0
                          ? getArabicNumber(state.ekskul[0].nilai_ekskul2)
                          : "-"}
                      </td>
                      <td className="border-element tw-w-[35%] tw-text-right">
                        {state.ekskul != null && state.ekskul.length > 0
                          ? state.ekskul[0].nama_ekskul2
                          : "-"}
                      </td>
                      <td className="border-element tw-w-[5%]">
                        {getArabicNumber("2")}
                      </td>
                    </tr>

                    <tr className="tw-h-[30px]">
                      <td className="border-element tw-w-[30%] tw-text-right">
                        {state.ekskul != null && state.ekskul.length > 0
                          ? state.ekskul[0].deskripsi_ekskul3
                          : "-"}
                      </td>
                      <td className="border-element tw-w-[30%]">
                        {state.ekskul != null && state.ekskul.length > 0
                          ? getArabicNumber(state.ekskul[0].nilai_ekskul3)
                          : "-"}
                      </td>
                      <td className="border-element tw-w-[35%] tw-text-right">
                        {state.ekskul != null && state.ekskul.length > 0
                          ? state.ekskul[0].nama_ekskul3
                          : "-"}
                      </td>
                      <td className="border-element tw-w-[5%]">
                        {getArabicNumber("3")}
                      </td>
                    </tr>
                  </tbody>
                </table>
                {/* end of ekskul */}
              </div>
              {/* end of body */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
